import React from "react";
import {
  LoginView,
  ValidateEmailView,
  RegistryView,
  HomeView,
  NotFoundView,
  ChallengesView,
  RewardsView,
  ProfileView,
  QuizzesView,
  QuizQuestionsView,
  PollsView,
  PollQuestionsView,
  DynamicsView,
  MenuView,
  PhotoView,
  PrivacyView,
  VerificationCodeView,
  RegistryProfileView,
  RoulettesView,
  RouletteView,
  ActivitiesView
} from "./views"

import { MainLayout } from "./layouts";

import { Navigate, Routes, Route } from "react-router-dom";

import RequireAuth from '@auth-kit/react-router/RequireAuth'

export default function Router() {
  return (
      <Routes>
        <Route path={'/main'} element={
            <RequireAuth fallbackPath={'/log-in'}>
              <MainLayout/>
            </RequireAuth>
          }>
            <Route path="home" element={<HomeView />}/>
            <Route path="challenges" element={<ChallengesView />}/>
            <Route path="rewards" element={<RewardsView />}/>
            <Route path="profile" element={<ProfileView />}/>
        </Route>

        <Route path={'/main/home'} element={
            <RequireAuth fallbackPath={'/log-in'}>
              <MainLayout/>
            </RequireAuth>
          }>
            <Route path="quizzes" element={<QuizzesView />}/>
            <Route path="dynamics" element={<MenuView />}/>
            <Route path="polls" element={<PollsView />}/>
            <Route path="roulettes" element={<RoulettesView />}/>
        </Route>

        <Route path={'/main/profile'} element={
            <RequireAuth fallbackPath={'/log-in'}>
              <MainLayout/>
            </RequireAuth>
          }>
            <Route path="activities" element={<ActivitiesView />}/>
        </Route>

        

        <Route path={'/main/home/quizzes'} element={
            <RequireAuth fallbackPath={'/log-in'}>
              <MainLayout/>
            </RequireAuth>
          }>
            <Route path="quiz-questionary" element={<QuizQuestionsView />}/>
        </Route>

        <Route path={'/main/home/polls'} element={
            <RequireAuth fallbackPath={'/log-in'}>
              <MainLayout/>
            </RequireAuth>
          }>
            <Route path="poll-questionary" element={<PollQuestionsView />}/>
        </Route>

        <Route path={'/main/home/roulettes'} element={
            <RequireAuth fallbackPath={'/log-in'}>
              <MainLayout/>
            </RequireAuth>
          }>
            <Route path="roulette" element={<RouletteView />}/>
        </Route>

       

        <Route path={'/main/home/dynamics'} element={
            <RequireAuth fallbackPath={'/log-in'}>
              <MainLayout/>
            </RequireAuth>
          }>
            <Route path="photo" element={<PhotoView />}/>
        </Route>


        <Route path={'/main/home/dynamics'} element={
            <RequireAuth fallbackPath={'/log-in'}>
              <MainLayout/>
            </RequireAuth>
          }>
            <Route path="list" element={<DynamicsView />}/>
        </Route>


        <Route path={'/log-in' } element={<LoginView/>}/>
        <Route path={'/validate-email' } element={<ValidateEmailView/>}/>
        <Route path={'/verification-code' } element={<VerificationCodeView/>}/>
        <Route path={'/registry' } element={<RegistryView/>}/>
        <Route path={'/registry-profile' } element={<RegistryProfileView/>}/>
        <Route path={'/privacy' } element={<PrivacyView/>}/>
        <Route path="/" element={<Navigate to="/main" replace />} />
        <Route path="/404" element={<NotFoundView />} />
        
        
      </Routes>


     
  )
}